import {Loading, Stack, useDelayMount} from '@treatwell/ui';
import styles from './LoadingSpinner.module.css';
import clsx from 'clsx';

export const LoadingSpinner = ({withOverlay}: {withOverlay?: boolean}) => {
  const isMounted = useDelayMount(500);
  const component = (
    <Stack fullHeight justify={withOverlay ? 'start' : 'center'} align="center">
      {isMounted && (
        <div
          data-cy="LoadingContainer"
          className={clsx(styles.container, {
            [styles.fixedContainer]: withOverlay,
          })}
        >
          <Loading delay={0} />
        </div>
      )}
    </Stack>
  );
  return withOverlay ? (
    <div className={styles.root} data-cy="LoadingSpinner">
      {component}
    </div>
  ) : (
    component
  );
};
